import {Message} from 'rctui';
import I18n from './Component/I18n';

const Utils = {
  notifyOnError: function (response) {
    if (response && response.Error) {
      Message.error(I18n.message(response.Error.Message, response.Error.Args),{ duration: 3 });
      return true;
    }

    return false;
  },
  error: function () {
    Message.error(i18n.get.apply(this, arguments),{ duration: 3 });
  
  },
  warning: function () {
    Message.warning(i18n.get.apply(this, arguments),{ duration: 3 });
  },
  success: function () {
    Message.success(i18n.get.apply(this, arguments),{ duration: 3 });
  },


  getObjectsDiff: function (objects, keys) {
    if (objects.length < 1) return null;
    if (objects.length === 1) return Object.assign({}, objects[0]);

    for (let i = 0; i < objects.length; i++) {
      if (this.isValue(objects[i])) {
        return this.compareValues(objects);
      }
    }

    let diff = {};

    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      if (objects.some(obj => 'undefined' == typeof (obj[key]))) {
        continue;
      }

      let objects_members = objects.map(function (obj) {
        return obj[key];
      });

      diff[key] = this.getObjectsDiff(objects_members, keys);
    }

    return diff;

  },
  compareValues: function (objects) {
    let first = objects[0];

    if (objects.every(obj => obj == first)) {
      return first;
    }

    return Constants.Diff;
  },
  isArray: function (obj) {
    return {}.toString.apply(obj) === '[object Array]';
  },
  isObject: function (obj) {
    return {}.toString.apply(obj) === '[object Object]';
  },
  isValue: function (obj) {
    return !this.isObject(obj) && !this.isArray(obj);
  }
};

export default Utils;



// WEBPACK FOOTER //
// ./src/js/Utils.js